import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  loading: false,
  colors: [],
  tastes: [],
  odors: [],
  states: [],
  symptoms: [],
  error: null,
  selectedObservations: []
}

export default {
  state,
  getters,
  mutations,
  actions
}
